import Borders from '@dynatrace/strato-design-tokens/borders';
import Colors from '@dynatrace/strato-design-tokens/colors';
import Spacings from '@dynatrace/strato-design-tokens/spacings';

import { dtVisualRefreshEnabled } from '../../core/components/app-root/AppRoot.sty.js';

export const vrResizeHandleContainerBaseOverrides = {
  backgroundColor: Colors.Background.Base.Default,
  backgroundImage: `linear-gradient(${Colors.Border.Neutral.Subdued}, ${Colors.Border.Neutral.Subdued})`,
  backgroundSize: `${Borders.Width.Default} 100%`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  borderRadius: 0,
  height: '100%',
  width: Spacings.Size8,
  left: 0,
  transition: 'none',
};

export const vrResizeHandleContainerInteractionOverrides = {
  [`.${dtVisualRefreshEnabled} &:hover`]: {
    backgroundImage: `linear-gradient(${Colors.Border.Neutral.SubduedHover}, ${Colors.Border.Neutral.SubduedHover})`,
  },
  [`.${dtVisualRefreshEnabled} &:active`]: {
    backgroundImage: `linear-gradient(${Colors.Border.Neutral.SubduedActive}, ${Colors.Border.Neutral.SubduedActive})`,
  },
};

export const vrResizeHandleContainerOverrides = {
  [`.${dtVisualRefreshEnabled} &`]: vrResizeHandleContainerBaseOverrides,
  ...vrResizeHandleContainerInteractionOverrides,
};

export const vrResizeHandleOverrides = {
  [`.${dtVisualRefreshEnabled} &`]: {
    width: 0,
    cursor: 'ew-resize',
  },
};

export const vrResizeHandleFocusOverrides = {
  backgroundImage: `linear-gradient(${Colors.Border.Neutral.Accent}, ${Colors.Border.Neutral.Accent})`,
  backgroundSize: `${Borders.Width.Emphasized} 100%`,
};
